import type { PieceJointe } from '@mairistem/comptabilite';
import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';

const getPiecesJointes = (params: URLSearchParams) => {
  const url = '/api/finances/comptabilite/piecesjointescomptabilite?';
  return request.get<unknown, TemplateRequestGet<PieceJointe>>(`${url}${params.toString()}`);
};

export default getPiecesJointes;
